import { ApiBind, Common } from './common.model';

/**
 * パスワード認証クラス
 * @remarks
 * パスワード認証情報を格納するクラス
 *
 */
export class PasswordAuth extends Common {

  @ApiBind({ column: 'user_name' })
  userName: string;

  @ApiBind({ column: 'password' })
  password: string;

}
